import React, { Component } from 'react'
import { connect } from 'react-redux'
import withStyles from 'isomorphic-style-loader/withStyles';
import { Field, reduxForm, formValueSelector, getFormSyncErrors } from 'redux-form';
import s from './ManageServiceFee.css'

import {
    Row,
    FormGroup,
    Col,
    Form,
    InputGroup,
    Container,
    OverlayTrigger,
    Popover,
    Tabs,
    Tab
} from 'react-bootstrap';
import cx from 'classnames';
import { injectIntl, FormattedMessage } from 'react-intl';
import messages from '../../../locale/messages'
import Loader from '../../Common/Loader/Loader';
import validate from './validate';
import submit from './submit';
import { getCurrencySymbol } from '../../../helpers/currencyConvertion';
import { hoursToTimeValue, timeValueToMinutes, surgeDurationMinutes, formatDuration } from './surgeTime';

const SURGE_FEE_FIELDS = ['bookingFee', 'shopFee', 'driverFee', 'deliveryFee', 'dropFee', 'distanceFee', 'extraDistanceFee', 'weightFee'];

// Form state keeps blank inputs as '' (controlled inputs); blank = use the normal fee.
function surgeToFormValues(surge) {
    const values = { isEnable: false, ...surge };
    values.startTime = surge ? hoursToTimeValue(surge.startTime) : '17:00';
    values.endTime = surge ? hoursToTimeValue(surge.endTime) : '19:00';
    SURGE_FEE_FIELDS.forEach(field => {
        values[field] = !surge || surge[field] === null || surge[field] === undefined ? '' : surge[field];
    });
    return values;
}

function toFormValues(initialValues) {
    return {
        ...initialValues,
        feeType: initialValues.feeType,
        bookingFeeDriverShare: initialValues.bookingFeeDriverShare != null ? initialValues.bookingFeeDriverShare * 100 : 100,
        bookingFeeCompanyShare: initialValues.bookingFeeCompanyShare != null ? initialValues.bookingFeeCompanyShare * 100 : 0,
        surge: surgeToFormValues(initialValues.surge)
    };
}


class ManageServiceFee extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            feeType: 'flatFee',
            activeTab: 'normal'
        }
    }

    handleDriverShareChange = (event) => {
        const { change } = this.props;
        let value = Number(event.target.value);
        if (value > 100) {
            value = 100;
        }
        if (!isNaN(value) && value >= 0 && value <= 100) {
            change('bookingFeeDriverShare', value);
            change('bookingFeeCompanyShare', 100 - value);
        } else if (event.target.value === '') {
            change('bookingFeeDriverShare', '');
            change('bookingFeeCompanyShare', '');
        }
    }

    handleCompanyShareChange = (event) => {
        const { change } = this.props;
        let value = Number(event.target.value);
        if (value > 100) {
            value = 100;
        }
        if (!isNaN(value) && value >= 0 && value <= 100) {
            change('bookingFeeCompanyShare', value);
            change('bookingFeeDriverShare', 100 - value);
        } else if (event.target.value === '') {
            change('bookingFeeDriverShare', '');
            change('bookingFeeCompanyShare', '');
        }
    }

    static defaultProps = {
        loading: false
    };

    componentDidMount() {
        const { initialValues } = this.props;
        if (initialValues) {
            this.setState({
                feeType: initialValues.feeType,
            });
            this.props.initialize(toFormValues(initialValues));
        } else {
            this.props.initialize({
                feeType: 'flatFee',
                bookingFeeDriverShare: 100,
                bookingFeeCompanyShare: 0,
                surge: surgeToFormValues(null)
            });
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { initialValues } = nextProps;
        if (initialValues && initialValues !== this.props.initialValues) {
            this.setState({
                feeType: initialValues.feeType,
            });
            // Reset form with new values
            this.props.initialize(toFormValues(initialValues));
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return (
            nextProps.initialValues !== this.props.initialValues ||
            nextState.feeType !== this.state.feeType ||
            nextState.activeTab !== this.state.activeTab ||
            nextProps.invalid !== this.props.invalid ||
            nextProps.submitting !== this.props.submitting ||
            nextProps.surgeStartTime !== this.props.surgeStartTime ||
            nextProps.surgeEndTime !== this.props.surgeEndTime ||
            nextProps.formSyncErrors !== this.props.formSyncErrors
        );
    }

    tabHasErrors(tab) {
        const errors = this.props.formSyncErrors || {};
        return tab === 'scheduled'
            ? Boolean(errors.surge)
            : Object.keys(errors).some(key => key !== 'surge');
    }

    renderTabTitle(text, tab) {
        return (
            <span>
                {text}
                {this.tabHasErrors(tab) && <span className={s.tabErrorDot} />}
            </span>
        );
    }

    handleFeeType(e) {
        const feeType = e.target.value;
        this.setState({
            feeType,
        });
        // Update form value when fee type changes
        this.props.change('feeType', feeType);
    }

    renderSelectField = ({
        input, label, type, meta: { touched, error }, labelClass, fieldClass, placeholder, children,
    }) => {
        const { formatMessage } = this.props.intl;
        return (
            <Form.Group className={s.space3}>
                <Form.Label>{label}</Form.Label>
                <Form.Control as="select" {...input} placeholder={placeholder} className={cx(fieldClass, s.formControlInput)}>
                    {children}
                </Form.Control>
                {touched && error && <span className={s.errorMessage}>{formatMessage(error)}</span>}
            </Form.Group>
        );
    }
    
    renderTimeField = ({ input, label, meta: { touched, error } }) => {
        const { formatMessage } = this.props.intl;
        return (
            <Form.Group className={s.space3}>
                <Form.Label>{label}</Form.Label>
                <Form.Control {...input} type="time" className={cx(s.formControlSelect, s.formControlInput)} />
                {touched && error && <span className={s.errorMessage}>{formatMessage(error)}</span>}
            </Form.Group>
        );
    }

    renderSurgeWindowSummary() {
        const { surgeStartTime, surgeEndTime } = this.props;
        const duration = surgeDurationMinutes(surgeStartTime, surgeEndTime);
        if (!duration) return null;

        const isOvernight = timeValueToMinutes(surgeEndTime) <= timeValueToMinutes(surgeStartTime);
        return (
            <p className={s.scheduledFeeWindow}>
                {`${surgeStartTime} – ${surgeEndTime} WITA · ${isOvernight ? 'past midnight · ' : ''}${formatDuration(duration)}`}
            </p>
        );
    }

    renderInfoIcon = (title, body) => (
        <OverlayTrigger
            trigger={['hover', 'focus']}
            placement="top"
            overlay={
                <Popover id={`popover-${title}`}>
                    <Popover.Title as="h3">{title}</Popover.Title>
                    <Popover.Content>{body}</Popover.Content>
                </Popover>
            }
        >
            <span className={s.infoIcon}>
                <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" />
                </svg>
            </span>
        </OverlayTrigger>
    )

    renderFieldDiscount = ({
        input, label, type, meta: { touched, error }, labelClass, fieldClass, placeholder, isPrice, currency, maxlength, unit, info,
    }) => {
        const { currentLocale } = this.props;
        const { formatMessage } = this.props.intl;
        return (
            <div className={cx('inputFormAddon', 'addonBorder')}>
                <Form.Group className={s.space3}>
                    <Form.Label className={cx(info && s.labelWithInfo)}>
                        {label}
                        {info && this.renderInfoIcon(info.title, info.body)}
                    </Form.Label>
                    <InputGroup>
                        {
                            isPrice == 1 && <InputGroup.Append>
                                <InputGroup.Text>
                                    {
                                        getCurrencySymbol(currency, currentLocale)
                                    }
                                </InputGroup.Text>
                            </InputGroup.Append>
                        }
                        <Form.Control {...input} placeholder={placeholder} type={type} className={cx(fieldClass, s.formControlInput)} maxLength={maxlength} />
                        {
                            isPrice != 1 && <InputGroup.Append>
                                <InputGroup.Text>{unit || '%'}</InputGroup.Text>
                            </InputGroup.Append>
                        }
                    </InputGroup>
                    {touched && error && <span className={s.errorMessage}>{formatMessage(error)}</span>}
                </Form.Group>
            </div>
        );
    }

    // Same order and two-column grid as the Normal Fee tab.
    renderScheduledFeeSection() {
        const { formatMessage } = this.props.intl;
        const { currency, distanceUnit, initialValues } = this.props;
        const isDistanceBased = this.state.feeType == 'distanceBasedFee';
        const perUnit = distanceUnit == 'km' ? '(per Km)' : '(per Mile)';
        const normalPlaceholder = field => (
            initialValues && initialValues[field] != null && initialValues[field] !== '' ? `Normal: ${initialValues[field]}` : 'Normal: not set'
        );
        const feeInputs = [
            { name: 'deliveryFee', label: isDistanceBased ? formatMessage(messages.pickupFee) : formatMessage(messages.deliveryFee), isPrice: 1 },
            isDistanceBased && { name: 'dropFee', label: formatMessage(messages.dropFee), isPrice: 1 },
            isDistanceBased && { name: 'distanceFee', label: `${formatMessage(messages.distanceFee)} ${perUnit}`, isPrice: 1 },
            isDistanceBased && { name: 'extraDistanceFee', label: `Extra Distance Fee ${perUnit}`, isPrice: 1 },
            { name: 'bookingFee', label: formatMessage(messages.bookingFee), isPrice: 2 },
            { name: 'shopFee', label: formatMessage(messages.shopFee), isPrice: 2 },
            { name: 'driverFee', label: formatMessage(messages.driverFee), isPrice: 2 },
            { name: 'weightFee', label: 'Weight Fee (per Kg, Grocery)', isPrice: 1 }
        ].filter(Boolean);

        return (
            <div>
                <div className={s.scheduledFeeHeader}>
                    <h3 className={s.scheduledFeeTitle}>Scheduled Fee</h3>
                    <p className={s.scheduledFeeSubtitle}>Replace the normal fees during a daily time range (WITA).</p>
                </div>
                <Row>
                    <Col xs={12} sm={12} md={12} lg={6}>
                        <Field
                            name="surge.isEnable"
                            component={this.renderSelectField}
                            label={formatMessage(messages.status)}
                            fieldClass={s.formControlSelect}
                        >
                            <option value={true}>{formatMessage(messages.enable)}</option>
                            <option value={false}>{formatMessage(messages.disable)}</option>
                        </Field>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} sm={12} md={12} lg={6}>
                        <Field
                            name="surge.startTime"
                            component={this.renderTimeField}
                            label={'Active From'}
                        />
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={6}>
                        <Field
                            name="surge.endTime"
                            component={this.renderTimeField}
                            label={'Active Until'}
                        />
                    </Col>
                </Row>
                {this.renderSurgeWindowSummary()}
                <hr className={s.scheduledFeeDivider} />
                <Row>
                    {
                        feeInputs.map(fee => (
                            <Col xs={12} sm={12} md={12} lg={6} key={fee.name} className={fee.isPrice == 1 ? 'borderRighOnly' : 'noRadiusLeft'}>
                                <Field
                                    name={`surge.${fee.name}`}
                                    type="text"
                                    label={fee.label}
                                    placeholder={normalPlaceholder(fee.name)}
                                    component={this.renderFieldDiscount}
                                    labelClass={s.labelText}
                                    className={cx(s.formControlSelect, s.formControlInput)}
                                    isPrice={fee.isPrice}
                                    currency={currency}
                                />
                            </Col>
                        ))
                    }
                </Row>
                <p className={s.scheduledFeeNote}>Leave a field empty to keep the normal fee.</p>
            </div>
        );
    }

    render() {
        const { formatMessage } = this.props.intl;
        const {
            handleSubmit, loading, submitting, invalid, currency, distanceUnit,
            initialValues
        } = this.props;
        const { feeType, activeTab } = this.state;
        
        return (
            <div>
                <Container fluid>
                    <form onSubmit={handleSubmit}>
                        <Row>
                            <Col xl={12} lg={8} md={12} sm={12} xs={12} className={s.blackCenter}>
                                <div className={s.blackCenterSection}>
                                    <Col xs={12} sm={12} md={12} lg={12}>
                                        <Tabs
                                            id="serviceFeeTabs"
                                            activeKey={activeTab}
                                            onSelect={tab => this.setState({ activeTab: tab })}
                                            className={s.feeTabs}
                                        >
                                            <Tab eventKey="normal" title={this.renderTabTitle('Normal Fee', 'normal')}>
                                                <div className={s.tabPane}>
                                                    <Row>
                                                        <Col xs={12} sm={12} md={12} lg={6}>
                                                            <Field
                                                                name="feeType"
                                                                placeholder={formatMessage(messages.feeType)}
                                                                component={this.renderSelectField}
                                                                label={formatMessage(messages.feeType)}
                                                                labelClass={s.labelText}
                                                                fieldClass={cx(s.formControlSelect)}
                                                                onChange={(e) => this.handleFeeType(e)}
                                                            >
                                                                <option value={"flatFee"}>{formatMessage(messages.flatFee)}</option>
                                                                <option value={"distanceBasedFee"}>{formatMessage(messages.distanceBasedFee)}</option>
                                                            </Field>
                                                        </Col>
                                                        <Col xs={12} sm={12} md={12} lg={6} className={'borderRighOnly'}>
                                                            <Field
                                                                name="deliveryFee"
                                                                type="text"
                                                                label={feeType == 'distanceBasedFee' ? formatMessage(messages.pickupFee) : formatMessage(messages.deliveryFee)}
                                                                placeholder={0}
                                                                component={this.renderFieldDiscount}
                                                                maxLength={8}
                                                                labelClass={s.labelText}
                                                                className={cx(s.formControlSelect, s.formControlInput)}
                                                                isPrice={1}
                                                                currency={currency}
                                                            />
                                                        </Col>

                                                        {feeType == 'distanceBasedFee' &&
                                                            <Col xs={12} sm={12} md={12} lg={6} className={'borderRighOnly'}>
                                                                <Field
                                                                    name="dropFee"
                                                                    type="text"
                                                                    label={formatMessage(messages.dropFee)}
                                                                    placeholder={0}
                                                                    component={this.renderFieldDiscount}
                                                                    maxLength={8}
                                                                    labelClass={s.labelText}
                                                                    className={cx(s.formControlSelect, s.formControlInput)}
                                                                    isPrice={1}
                                                                    currency={currency}
                                                                />
                                                            </Col>
                                                        }
                                                        {feeType == 'distanceBasedFee' &&
                                                            <Col xs={12} sm={12} md={12} lg={6} className={'borderRighOnly'}>
                                                                <Field
                                                                    name="distanceFee"
                                                                    type="text"
                                                                    label={`${formatMessage(messages.distanceFee)} ${distanceUnit == 'km' ? "(per Km)" : "(per Mile)"}`}
                                                                    placeholder={0}
                                                                    component={this.renderFieldDiscount}
                                                                    maxLength={8}
                                                                    labelClass={s.labelText}
                                                                    className={cx(s.formControlSelect, s.formControlInput)}
                                                                    isPrice={1}
                                                                    currency={currency}
                                                                />
                                                            </Col>
                                                        }

                                                        {feeType == 'distanceBasedFee' &&
                                                            <Col xs={12} sm={12} md={12} lg={6} className={'borderRighOnly'}>
                                                                <Field
                                                                    name="normalDistanceLimitKm"
                                                                    type="text"
                                                                    label={'Normal Price Distance Limit'}
                                                                    placeholder={0}
                                                                    component={this.renderFieldDiscount}
                                                                    maxLength={4}
                                                                    labelClass={s.labelText}
                                                                    className={cx(s.formControlSelect, s.formControlInput)}
                                                                    isPrice={2}
                                                                    unit={distanceUnit == 'km' ? 'Km' : 'Mile'}
                                                                    info={{
                                                                        title: 'Normal Distance Limit',
                                                                        body: `Distance charged at the normal Distance Fee. Beyond this limit, the Extra Distance Fee applies. Leave empty to use one rate for the whole trip.`
                                                                    }}
                                                                />
                                                            </Col>
                                                        }
                                                        {feeType == 'distanceBasedFee' &&
                                                            <Col xs={12} sm={12} md={12} lg={6} className={'borderRighOnly'}>
                                                                <Field
                                                                    name="extraDistanceFee"
                                                                    type="text"
                                                                    label={`Extra Distance Fee ${distanceUnit == 'km' ? "(per Km)" : "(per Mile)"}`}
                                                                    placeholder={0}
                                                                    component={this.renderFieldDiscount}
                                                                    maxLength={8}
                                                                    labelClass={s.labelText}
                                                                    className={cx(s.formControlSelect, s.formControlInput)}
                                                                    isPrice={1}
                                                                    currency={currency}
                                                                    info={{
                                                                        title: 'Extra Distance Fee',
                                                                        body: `Rate for each ${distanceUnit == 'km' ? 'Km' : 'Mile'} beyond the Normal Distance Limit. Example: limit 10, normal 2,500, extra 4,000 — a 20 Km trip costs (10 x 2,500) + (10 x 4,000).`
                                                                    }}
                                                                />
                                                            </Col>
                                                        }

                                                        <Col xs={12} sm={12} md={12} lg={6} className='noRadiusLeft'>
                                                            <Field
                                                                name="bookingFee"
                                                                type="text"
                                                                label={formatMessage(messages.bookingFee)}
                                                                placeholder={"%"}
                                                                component={this.renderFieldDiscount}
                                                                labelClass={s.labelText}
                                                                className={cx(s.formControlSelect, s.formControlInput)}
                                                                isPrice={2}
                                                                maxLength={3}
                                                            />
                                                        </Col>
                                           
                                                        <Col xs={12} sm={12} md={12} lg={6} className='noRadiusLeft'>
                                                            <Field
                                                                name="shopFee"
                                                                type="text"
                                                                label={formatMessage(messages.shopFee)}
                                                                placeholder={"%"}
                                                                component={this.renderFieldDiscount}
                                                                labelClass={s.labelText}
                                                                className={cx(s.formControlSelect, s.formControlInput)}
                                                                isPrice={2}
                                                                maxLength={2}
                                                            />
                                                        </Col>
                                                         <Col xs={12} sm={12} md={12} lg={12} className='noRadiusLeft'>
                                                            <Row>
                                                                <Col xs={12} sm={12} md={6} lg={6}>
                                                                    <Field
                                                                        name="bookingFeeDriverShare"
                                                                        type="text"
                                                                        label={'Booking Fee Driver Share'}
                                                                        placeholder={"%"}
                                                                        component={this.renderFieldDiscount}
                                                                        labelClass={s.labelText}
                                                                        className={cx(s.formControlSelect, s.formControlInput)}
                                                                        isPrice={2}
                                                                        maxLength={3}
                                                                        onChange={this.handleDriverShareChange}
                                                                    />
                                                                </Col>
                                                                <Col xs={12} sm={12} md={6} lg={6}>
                                                                    <Field
                                                                        name="bookingFeeCompanyShare"
                                                                        type="text"
                                                                        label={'Booking Fee Company Share'}
                                                                        placeholder={"%"}
                                                                        component={this.renderFieldDiscount}
                                                                        labelClass={s.labelText}
                                                                        className={cx(s.formControlSelect, s.formControlInput)}
                                                                        isPrice={2}
                                                                        maxLength={3}
                                                                        onChange={this.handleCompanyShareChange}
                                                                    />
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                        <Col xs={12} sm={12} md={12} lg={6} className='noRadiusLeft'>
                                                            <Field
                                                                name="driverFee"
                                                                type="text"
                                                                label={formatMessage(messages.driverFee)}
                                                                placeholder={"%"}
                                                                component={this.renderFieldDiscount}
                                                                labelClass={s.labelText}
                                                                className={cx(s.formControlSelect, s.formControlInput)}
                                                                isPrice={2}
                                                                maxLength={2}
                                                            />
                                                        </Col>

                                                    </Row>
                                                </div>
                                            </Tab>
                                            <Tab eventKey="scheduled" title={this.renderTabTitle('Scheduled Fee', 'scheduled')}>
                                                <div className={s.tabPane}>
                                                    {this.renderScheduledFeeSection()}
                                                </div>
                                            </Tab>
                                        </Tabs>
                                    </Col>
                                </div>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={12} className={cx(s.textAlignRight, s.btnPadding, 'textAlignLeftRTL', 'btnPaddingRTL')}>
                                <FormGroup className={s.noMargin}>
                                    <div>
                                        <Loader
                                            type={"button"}
                                            label={formatMessage(messages.submitButton)}
                                            show={loading || submitting}
                                            buttonType={'submit'}
                                            className={cx(s.button, s.btnPrimary)}
                                            disabled={submitting || loading || invalid}
                                            isSuffix={true}
                                        />
                                    </div>
                                </FormGroup>
                            </Col>
                        </Row>
                    </form>
                </Container>
            </div>
        )
    }

}

ManageServiceFee = reduxForm({
    form: 'ServiceFeeForm',
    validate,
    onSubmit: submit
})(ManageServiceFee)

const selector = formValueSelector('ServiceFeeForm');

const mapState = state => ({
    feeType: selector(state, 'feeType'),
    surgeStartTime: selector(state, 'surge.startTime'),
    surgeEndTime: selector(state, 'surge.endTime'),
    formSyncErrors: getFormSyncErrors('ServiceFeeForm')(state),
    currency: state.siteSettings.data.currency,
    distanceUnit: state.siteSettings.data.distanceUnits,
    currentLocale: state.intl.locale,
})

const mapDispatch = {

}

export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(ManageServiceFee)));